import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  connect() {
    // Close any other open modals first
    document.querySelectorAll('.modal.show').forEach(modal => {
      const modalInstance = Modal.getInstance(modal)
      if (modalInstance) {
        modalInstance.hide()
      }
    })
    
    this.modal = new Modal(this.element)
    this.modal.show()
    this.element.addEventListener('hidden.bs.modal', this.removeModal)
  }

  disconnect() {
    this.element.removeEventListener('hidden.bs.modal', this.removeModal)
    // Clean up any leftover backdrops
    document.querySelectorAll('.modal-backdrop').forEach(backdrop => backdrop.remove())
  }

  removeModal = () => {
    this.element.remove()
  }
}
